import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";

const buttonStyle = (theme: Theme) => createStyles({
    button: {
        color: theme.palette.common.white,
        textTransform: "uppercase",
        letterSpacing: "0",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        touchAction: "manipulation",

        "&:hover,&:focus": {
            backgroundColor: theme.palette.grey[500],
            boxShadow:
                "0 14px 26px -12px rgba(153, 153, 153, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(153, 153, 153, 0.2)"
        },
        "& .fab,& .fas,& .far,& .fal, &.material-icons": {
            position: "relative",
            display: "inline-block",
            top: "0",
            marginTop: "-1em",
            marginBottom: "-1em",
            verticalAlign: "middle"
        },
        "& svg": {
            position: "relative",
            display: "inline-block",
            top: "0",
            verticalAlign: "middle",
        },
        "&$justIcon": {
            "& .fab,& .fas,& .far,& .fal,& .material-icons": {
                marginTop: "0px",
                position: "absolute",
                width: "100%",
                transform: "none",
                left: "0px",
                top: "0px",
                height: "100%",
                lineHeight: "41px",
            }
        },
        "&$button + &$button": {
            marginLeft: ".5rem",
        },
    },

    fakeButton: {
        padding: "6px 8px",
        "&:first-child": {
            paddingLeft: 0,
        },
        "&$fakeButton + &$fakeButton": {
            marginLeft: ".5rem",
        },
    },

    iconsSizeSmall: {
        "& .fab,& .fas,& .far,& .fal, &.material-icons": {
            fontSize: "0.8rem",
        },
        "& svg": {
            fontSize: "0.9rem",
        },
    },

    iconsSizeNormal: {
        "& .fab,& .fas,& .far,& .fal, &.material-icons": {
            fontSize: "1.1rem",
        },
        "& svg": {
            fontSize: "1.2rem",
        },
    },

    iconsSizeLarge: {
        "& .fab,& .fas,& .far,& .fal, &.material-icons": {
            fontSize: "1.4rem",
        },
        "& svg": {
            fontSize: "1.5rem",
        },
    },

    widthLarge: {
        minWidth: "10rem",
    },
    widthSmall: {
        minWidth: "8rem",
    },
    widthFit: {
        minHeight: "auto",
        minWidth: "auto",
    },

    white: {
        "&,&:focus,&:hover": {
            backgroundColor: theme.palette.grey[500],
        }
    },
    primary: {
        backgroundColor: theme.palette.primary.dark,
        "&:hover,&:focus": {
            backgroundColor: theme.palette.primary.main,
            boxShadow:
                "0 14px 26px -12pxr gba(39, 98, 176, 0.28), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(156, 39, 176, 0.2)"
        }
    },
    secondary: {
        backgroundColor: theme.palette.secondary.dark,
        "&:hover,&:focus": {
            backgroundColor: theme.palette.secondary.main,
            boxShadow:
                "0 14px 26px -12pxr gba(39, 98, 176, 0.28), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(156, 39, 176, 0.2)"
        }
    },
    pressed: {
        backgroundColor: theme.genie.palette.pressed.dark,
        "&:hover,&:focus": {
            backgroundColor: theme.genie.palette.pressed.main,
            boxShadow:
                "0 14px 26px -12px rgba(255, 152, 0, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(255, 152, 0, 0.2)"
        }
    },
    info: {
        backgroundColor: theme.genie.palette.info.dark,
        "&:hover,&:focus": {
            backgroundColor: theme.genie.palette.info.main,
            boxShadow:
                "0 14px 26px -12px rgba(0, 188, 212, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 188, 212, 0.2)"
        }
    },
    success: {
        backgroundColor: theme.genie.palette.success.dark,
        "&:hover,&:focus": {
            backgroundColor: theme.genie.palette.success.main,
            boxShadow:
                "0 14px 26px -12px rgba(76, 175, 80, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(76, 175, 80, 0.2)"
        }
    },
    warning: {
        backgroundColor: theme.genie.palette.warning.dark,
        "&:hover,&:focus": {
            backgroundColor: theme.genie.palette.warning.main,
            boxShadow:
                "0 14px 26px -12px rgba(255, 152, 0, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(255, 152, 0, 0.2)"
        }
    },
    muted: {
        color: theme.genie.palette.muted.main,
        "&:hover,&:focus": {
            backgroundColor: "inherit",
            boxShadow: "inherit"
        }

    },
    error: {
        backgroundColor: theme.palette.error.dark,
        "&:hover,&:focus": {
            backgroundColor: theme.palette.error.main,
            boxShadow:
                "0 14px 26px -12px rgba(244, 67, 54, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(244, 67, 54, 0.2)"
        }
    },
    inherit: {
        backgroundColor: "inherit",
        color: "inherit",
        boxShadow: "inherit"
    },
    transparent: {
        "&,&:focus,&:hover": {
            color: "inherit",
            background: "transparent",
            boxShadow: "none"
        }
    },
    default: {
        backgroundColor: theme.palette.grey[500],
    },

    simple: {
        minHeight: "auto",
        minWidth: "auto",
        "&,&:focus,&:hover": {
            background: "transparent",
            boxShadow: "none"
        },
        "&$default": {
            "&,&:focus,&:hover,&:visited": {
                color: theme.palette.common.black
            }
        },
        "&$inherit": {
            "&,&:focus,&:hover,&:visited": {
                color: "inherit"
            }
        },
        "&$primary": {
            "&,&:focus,&:hover,&:visited": {
                color: theme.palette.primary.main
            }
        },
        "&$secondary": {
            "&,&:focus,&:hover,&:visited": {
                color: theme.palette.secondary.main
            }
        },

        "&$pressed": {
            "&,&:focus,&:hover,&:visited": {
                color: theme.genie.palette.pressed.main
            }
        },
        "&$info": {
            "&,&:focus,&:hover,&:visited": {
                color: theme.genie.palette.info.main
            }
        },
        "&$success": {
            "&,&:focus,&:hover,&:visited": {
                color: theme.genie.palette.success.main
            }
        },
        "&$warning": {
            "&,&:focus,&:hover,&:visited": {
                color: theme.genie.palette.warning.main
            }
        },
        "&$muted": {
            "&,&:focus,&:hover,&:visited": {
                color: theme.genie.palette.muted.main
            }
        },
        "&$error": {
            "&,&:focus,&:hover,&:visited": {
                color: theme.palette.error.main
            }
        },
    },

    link: {
        "&,&:hover,&:focus": {
            backgroundColor: "transparent",
            boxShadow: "none",
            color: theme.palette.common.black
        },
        "&$default": {
            color: theme.palette.grey[500]
        },
        "&$primary": {
            color: theme.palette.primary.main
        },
        "&$secondary": {
            color: theme.palette.secondary.main
        },
        "&$success": {
            color: theme.genie.palette.success.main
        },
        "&$error": {
            color: theme.palette.error.main
        },
        "&$info": {
            color: theme.genie.palette.info.main
        },
        "&$warning": {
            color: theme.genie.palette.warning.main
        },
        "&$pressed": {
            color: theme.genie.palette.pressed.main
        },
        "&$muted": {
            color: theme.genie.palette.muted.main
        },
        "&$white": {
            color: theme.palette.grey[500]
        },
        "&$inherit": {
            backgroundColor: "inherit",
            color: "inherit"
        }
    },

    justIcon: {
        minWidth: "41px",
        width: "41px",
        "& .fab,& .fas,& .far,& .fal,& svg,& .material-icons": {
            marginRight: "0px"
        },
        "&$lg": {
            minWidth: "57px",
            width: "57px",
            lineHeight: "56px",
            "& .fab,& .fas,& .far,& .fal,& .material-icons": {
                fontSize: "32px",
                lineHeight: "56px"
            },
            "& svg": {
                width: "32px",
                height: "32px"
            }
        },
        "&$sm": {
            minWidth: "30px",
            width: "30px",
            "& .fab,& .fas,& .far,& .fal,& .material-icons": {
                fontSize: "17px",
                lineHeight: "29px"
            },
            "& svg": {
                width: "17px",
                height: "17px"
            }
        }
    },

    disabled: {
        opacity: 0.35,
        pointerEvents: "none"
    },

    lg: {
        padding: "8px 10px",
        fontSize: "0.875rem",
    },
    sm: {
        padding: "4px 6px",
        fontSize: "0.6875rem",
    },

    round: {
        borderRadius: "30px"
    },

    block: {
        width: "100% !important"
    },


    noPadding: {
        padding: 0
    },

    noMargin: {
        margin: 0
    },

    noPress: {
        "pointer-events": "none"
    },

});

export default buttonStyle;
